export default __webpack_public_path__ + "static/media/tenant_3.5574d2c3.png";